import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../src/app/auth/auth.guard';

import { ContentmanagementComponent } from './contentmanagement/contentmanagement.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'contentmgmt',
    pathMatch: 'full'
  },
  { path: 'contentmgmt',
    component: ContentmanagementComponent,
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
